import type ExecutionStepPhase from "./ExecutionStepPhase";

/**
 * What a node is in the middle of, as far as the walkthroughs are concerned.
 *
 * One field instead of the five flags and enums this replaces. Those could
 * disagree with each other — a node marked done while also flagged as the one
 * to pick next, a phase left behind on a node no longer being evaluated — and
 * the frame had to rank them by hand to arrive at a single border color. A
 * union can only ever say one thing, so there is nothing left to rank.
 *
 * - `idle`: no walkthrough is running
 * - `waiting`: one is, and it hasn't reached this node
 * - `ready`: the manual walkthrough will accept this node next
 * - `active`: this node is being evaluated right now, for the phase given
 * - `done`: this node has been evaluated
 */
type NodeWalkthroughState =
  | { status: "idle" }
  | { status: "waiting" }
  | { status: "ready" }
  | { status: "active"; phase: ExecutionStepPhase }
  | { status: "done" };

/**
 * The state of a node while nothing is walking the graph, which is also what a
 * node loaded from a file saved before any of this existed amounts to.
 */
const idleWalkthroughState: NodeWalkthroughState = { status: "idle" };

export default NodeWalkthroughState;
export { idleWalkthroughState };
